import { Table, Tag, Tooltip, Space } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import CustomButton from '../../component/button';
import { Check,XCircle,X,MessageSquare,AlertTriangle,Bot,ChevronRight } from 'lucide-react';
import { Modal,Form } from 'react-bootstrap';
import ReactQuilInput from '../../component/ReactQuilInput';
import { useState } from 'react';
import SideDrawer from '../../component/sideDrawer';
import StatusBadge from '../../component/StsusBadge';

const DRAWER_CSS = `
.lywo-bubble { max-width: 80%; }
.lywo-bubble--me { border-top-right-radius: .25rem !important; }
.lywo-bubble--ai { border-top-left-radius: .25rem !important; }
.lywo-label { font-size: 10px; letter-spacing: .04em; }
.lywo-section-title { letter-spacing: .08em; }
.lywo-card-label { font-size: 10px; }
.btn-primary-brand { background: var(--brand-primary); border-color: var(--brand-primary); color: #fff; }
`;

const STATUS_COLORS = {
  'Screening Complete': 'green',
  'Pending Response': 'gold',
};

const RECO_COLORS = {
  Recommended: 'success',
  'Maybe Not': 'warning',
  Unsure: 'default',
};

const SENDER_COLORS = {
  AI: 'blue',
  Candidate: 'geekblue',
  System: 'red',
};

let transcript =[
      { sender: 'AI', text: "Hi Alexia! I'm LYWO's AI assistant. Ready for a quick chat about the Senior Frontend role?" },
      { sender: 'Candidate', text: "Yes, absolutely! Happy to chat." },
      { sender: 'AI', text: "Great. First, are you still interested in this position and comfortable with a hybrid work setup in New York?" },
      { sender: 'Candidate', text: "Yes, I am currently based in Brooklyn so hybrid in NY is perfect." },
      { sender: 'AI', text: "Let's dive into a quick technical question. How do you handle state management in a large-scale React application?" },
      { sender: 'Candidate', text: "I typically use Redux Toolkit for global state, but I lean heavily on React Query for server state caching. It keeps the UI snappy and reduces boilerplate." }
    ]

     const getBadgeClass = (rec) => {
    switch(rec) {
      case 'Recommended': return 'badge-excellent';
      case 'Maybe Not': return 'badge-normal';
      case 'Unsure': return 'badge-unsure';
      default: return 'badge-unsure';
    }
  };




export default function CandidateTable({MOCK_CANDIDATES,selectedIds,toggleSelect,toggleSelectAll}) {


    const [mails,setMails] = useState({isOpen:false,type:''})


      const [candidate, setSelectedCandidate] = useState(null);

      const [showMailTest,setShowMailTest] = useState(false)

      const [showReview,setShowReview] = useState(false)

    const columns = [
    {
              title: () => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    defaultValue={false}
                    checked={selectedIds.length === MOCK_CANDIDATES.length && MOCK_CANDIDATES.length > 0}
                    onChange={toggleSelectAll}
                  />
                </div>
              ),
              fixed: "left",
              width: 20,
              render: (text, record, index) => {
                // const truncatedText =
                //   record.name?.length > 12
                //     ? record.name?.slice(0, 12) + "..."
                //     : record.name;
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                        checked={selectedIds.includes(record.id)}
                        onChange={() => toggleSelect(record.id)}
                    />
    
                  </div>
                );
              },
            },
  
  {
    title: 'Candidate Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (name, record) => (
      <Space>
        {name}
        {record?.fraudFlag && (
          <Tooltip title={record.fraudReason || 'Fraud flag raised'}>
            <WarningFilled style={{ color: '#cf1322' }} />
          </Tooltip>
        )}
      </Space>
    ),
  },
  {
    title: 'Applied Date',
    dataIndex: 'appliedDate',
    key: 'appliedDate',
    // string dates sort correctly only if parsed — see note below
    sorter: (a, b) => new Date(a.appliedDate) - new Date(b.appliedDate),
  },
  {
    title: 'Token Expiry',
    dataIndex: 'tokenExpiry',
    key: 'tokenExpiry',
    sorter: (a, b) => new Date(a.tokenExpiry) - new Date(b.tokenExpiry),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: [
      { text: 'Screening Complete', value: 'Screening Complete' },
      { text: 'Pending Response', value: 'Pending Response' },
    ],
    onFilter: (value, record) => record.status === value,
    // render: (status) => {status},
  },
  {
    title:  'Ai Recommendation',
    dataIndex: 'recommendation',
    key: 'recommendation',
    filters: [
      { text: 'Recommended', value: 'Recommended' },
      { text: 'Maybe Not', value: 'Maybe Not' },
      { text: 'Unsure', value: 'Unsure' },
    ],
    onFilter: (value, record) => record.recommendation === value,
    render: (reco) =>   <StatusBadge status={reco}/> ,
  },
  {
    title: 'Alerts',
    dataIndex: 'fraudFlag',
    key: 'fraudFlag',
    width: 90,
    // align: 'center',
    filters: [
      { text: 'Flagged', value: true },
      { text: 'Clean', value: false },
    ],
    onFilter: (value, record) => record.fraudFlag === value,
    render: (flag, record) =>
      flag ? (
        <Tooltip title={record.fraudReason}>
          <StatusBadge status="Flagged"/>
        </Tooltip>
      ) : (
        <StatusBadge status="Clean"/>
      ),
  },
  {
    title:  'Actions',
    dataIndex: 'actions',
    render: (reco) => <div>
         <CustomButton title={'Review'} buttonType='secondary'
         handleClick={()=>{setSelectedCandidate(reco)
            setShowReview(true)
         }}
         />
         <button
                           onClick={() => setMails({isOpen:true,type:""})}
                          className="btn btn-ghost text-green-600 hover:bg-green-50 p-1 min-h-0 h-8 w-8 border border-transparent hover:border-green-200"
                          title="Advance Candidate"
                        >
                          <Check size={16} />
                        </button>
                        <button
                           onClick={() => setMails({isOpen:true,type:""})}
                          className="btn btn-ghost text-red-600 hover:bg-red-50 p-1 min-h-0 h-8 w-8 border border-transparent hover:border-red-200"
                          title="Respectful Decline"
                        >
                          <XCircle size={16} />
                        </button>
    </div>,
  },
];
  return (
    <>   
     <Table
      rowKey="id"
      columns={columns}
      dataSource={MOCK_CANDIDATES}
    //   scroll={{ x: 900 }}
    //   pagination={{ pageSize: 10 }}
    //   expandable={{
    //     expandedRowRender: (record) => (
    //       <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
    //         {record.transcript.map((msg, i) => (
    //           <div key={i}>
    //             <Tag color={SENDER_COLORS[msg.sender] || 'default'}>{msg.sender}</Tag>
    //             <span>{msg.text}</span>
    //           </div>
    //         ))}
    //       </div>
    //     ),
    //     rowExpandable: (record) => Array.isArray(record.transcript) && record.transcript.length > 0,
    //   }}
    />

              <Modal show={mails.isOpen} 
              onHide={()=>setMails({isOpen:false,type:""})}
               zIndex={1200}
               size="lg" dialogClassName="modal-h-650"
                backdropClassName="drawer-modal-backdrop"   // raise the backdrop
  style={{ zIndex: 1200 }} 
               >
                          <Modal.Header closeButton className="custom-close-btn">
                              {/* <h6 className="mb-0 mt-1">Application</h6> */}
                          </Modal.Header>
                          <Modal.Body>
                              <div>

                                      <div className="d-flex mt-1">
                                          <Form.Label style={{ width: "50px" }}>To</Form.Label>
              
                                          <p>
                                              <span>1</span> Respondent
                                              {/* {selects.length === 1 ? "" : "s"} selected */}
                                          </p>
                                      </div>
                                       <div className="d-flex">
                                                                  <Form.Label className="" style={{ width: "50px" }}>
                                                                      Excl
                                                                  </Form.Label>
                                                                  <p>
                                                                    {2} Not Interested,   {1} Completed
                                                                  </p>
                                                              </div>
                                  <Form.Group>
                                      <div className="d-flex align-items-center mb-3">
                                          <Form.Label className="me-2">Subject</Form.Label>
                                          <Form.Control
                                              type="text"
                                            //   value={subject}
                                            //   onChange={(e) => setSubject(e.target.value)}
                                          />
                                      </div>
                                  </Form.Group>
                                  {/* {from && ( */}
                                      <div className="d-flex mt-1">
                                          <Form.Label className="me-1" style={{ width: "50px" }}>
                                              From
                                          </Form.Label>
                                          <p>sameer.kutty@cloudxperte.com</p>
                                      </div>
                                  {/* )} */}
                                  <Form.Group>
                                      <div className="d-flex align-items-center mb-3">
                                          <Form.Label className="me-2" style={{ width: "43px", marginTop: '5px' }}>
                                              Cc
                                          </Form.Label>
                                          <div
                                              style={{
                                                  flex: 1,
                                                  // border: "1px solid #ccc",
                                                  // borderRadius: "5px",
                                              }}
                                          >
                                              {/* {ccEmails.map((x, index) => (
                                                  <Badge
                                                      pill
                                                      key={index}
                                                      bg="secondary"
                                                      className="m-1"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => removeEmail(x)}
                                                  >
                                                      {x}
                                                  </Badge>
                                              ))} */}
                                              <Form.Control
                                                  type="text"
                                                //   value={inputValue}
                                                //   onChange={(e) => setInputValue(e.target.value)}
                                                  placeholder="Add email and press enter"
                                                //   onKeyDown={handleKeyDown}
              
                                                  style={{
                                                      border: "none !important",
              
              
                                                  }}
                                              ></Form.Control>
                                          </div>
                                      </div>
                                  </Form.Group>
                                  <div style={{ height: "200px" }}>
                                      <ReactQuilInput/>
                                  </div>
                              </div>
                              <div className="d-flex justify-content-between mt-4 align-items-center">
                                <div className=" d-flex mt-1 ml-1 gap-2">
                        <span> Use last sent template</span>

                        <Form.Check
                            // checked={isDefaultEmailContent}
                            type="switch"
                            id={"custom-switch"}
                            style={{ marginTop: '-6pX' }}
                            className="custom-switch"
                           
                        // disabled={isDefaultEmailContent}
                        />
                        <span style={{ marginLeft: '0px' }}>Fetch default template</span>
                    </div>
                                  <div className="d-flex gap-1">
                                    <CustomButton
                                    title='Test Email'
                                    handleClick={()=>{
                                      setShowMailTest(true)
                                    }}
                                    buttonType='secondary'
                                    />
                                    <CustomButton
                                    title="Send"
                                    handleClick={()=>{}}
                                    />
                                  </div>
                              </div>
                          </Modal.Body>
                      </Modal>

 <Modal show={showMailTest}
  centered 
  onHide={()=>setShowMailTest(false
    
  )}
       backdropClassName="drawer-modal-backdrop-two"   // raise the backdrop
  style={{ zIndex: 1300 }} 
 
 size="lg" dialogClassName="modal-h-650">
            <Modal.Header closeButton className="custom-close-btn">
                <h6 className="mb-0 mt-1">Test Email</h6>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form.Group>
                        {/* {from && ( */}
                            <div className="d-flex">
                                <Form.Label style={{ width: "50px" }}>From</Form.Label>

                                <p>{"Sameer.kutty@cloudxperte.com"}</p>
                            </div>
                        {/* )} */}
                    </Form.Group>
                    <Form.Group>
                        <div className="d-flex align-items-center mb-3">
                            <Form.Label style={{ width: "50px", marginTop: '5px' }}>To </Form.Label>
                            <div
                                style={{
                                    flex: 1,
                                    // border: "1px solid #ccc",
                                    // borderRadius: "5px",
                                }}
                            >
                                {/* {toEmails.map((x, index) => (
                                    <Badge
                                        pill
                                        key={index}
                                        bg="secondary"
                                        className="m-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => removeEmailTest(x)}
                                    >
                                        {x}
                                    </Badge>
                                ))} */}
                                <Form.Control
                                    type="text"
                                    // value={inputValueTest}
                                    // onChange={(e) => setInputValueTest(e.target.value)}
                                    placeholder="Add email and press enter"
                                    // onKeyDown={handleKeyDownTest}
                                    className="border-0"
                                // style={{
                                //   border: "none",
                                //   display: "inline-block",
                                //   width: "auto",
                                // }}
                                ></Form.Control>
                            </div>
                        </div>
                    </Form.Group>
                    <div style={{ height: "200px" }}>
                      <ReactQuilInput/>
                        
                    </div>
                </div>
                <div className="row justify-content-end mt-4">
                    <div className="col-2 d-flex justify-content-end">
                      <CustomButton
                      title="Send"
                      handleClick={()=>{}}
                      />
                    </div>
                </div>
            </Modal.Body>
        </Modal>

      <SideDrawer isOpen={showReview}>

    <>
      <style>{DRAWER_CSS}</style>

      <div className="d-flex flex-column bg-white" style={{ height: '100vh' }}>

        {/* HEADER */}
        <div className="p-4 border-bottom d-flex justify-content-between align-items-start bg-white">
          <div>
            <div className="d-flex align-items-center gap-3 mb-1">
              <h1 className="h4 m-0">Alexia Vance</h1>
              <span 
              className={`badge rounded-pill ${getBadgeClass('Recommended')}`}
              >
                AI: Recommended {candidate?.recommendation}
              </span>
            </div>
            <p className="small text-muted m-0">
              Applied: Oct 24, 2026 • ID: 4202
            </p>

            {candidate?.fraudFlag && (
              <div className="mt-2 d-flex align-items-center gap-2 p-2 bg-danger-subtle border border-danger-subtle text-danger rounded small fw-medium">
                <AlertTriangle size={16} />
                {candidate?.fraudReason}
              </div>
            )}
          </div>

          <button
            onClick={() => {setShowReview(false)}}
            className="btn btn-sm btn-light text-secondary rounded-circle p-1 lh-1 border-0"
          >
            <X size={20} />
          </button>
        </div>

        {/* BODY */}
        <div className="flex-grow-1 overflow-auto p-4 bg-light">

          {/* Summary */}
          <div className="mb-4">
            <h3 className="small fw-bold text-dark mb-3 text-uppercase lywo-section-title">
              Screening Summary
            </h3>
            <div className="row g-2">
              {[
                { label: 'Interest', status: 'Verified' },
                { label: 'Requirements', status: 'Met (Hybrid NY)' },
                { label: 'Technical', status: 'Completed' },
                { label: 'Behaviour', status: 'Skipped' },
                { label: 'Logistics', status: 'Available Mon-Wed' },
                { label: 'Referrals', status: 'None' },
              ].map((item, idx) => (
                <div className="col-6" key={idx}>
                  <div className="bg-white p-2 rounded border shadow-sm d-flex flex-column h-100">
                    <span className="text-muted fw-semibold text-uppercase lywo-card-label">
                      {item.label}
                    </span>
                    <h4 className="small text-dark fw-bold">{item.status}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Transcript */}
          <div>
            <h3 className="small fw-bold text-dark mb-3 text-uppercase lywo-section-title d-flex align-items-center gap-2">
              <MessageSquare size={14} /> Raw Chat Transcript
            </h3>
            <div className="d-flex flex-column gap-3">
              {transcript?.map((msg, idx) => (
                <div
                  key={idx}
                  className={`d-flex ${msg.sender === 'Candidate' ? 'justify-content-end' : 'justify-content-start'}`}
                >
                  {msg.sender === 'System' ? (
                    <div className="w-100 text-center my-1 small fw-bold text-danger bg-danger-subtle py-1 rounded border border-danger-subtle">
                      {msg.text}
                    </div>
                  ) : (
                    <div
                      className={`lywo-bubble rounded-3 p-2 small ${
                        msg.sender === 'Candidate'
                          ? 'btn-primary-brand lywo-bubble--me'
                          : 'bg-white border text-dark shadow-sm lywo-bubble--ai'
                      }`}
                    >
                      {msg.sender === 'AI' && (
                        <div className="lywo-label fw-bold text-primary mb-1 d-flex align-items-center gap-1 text-uppercase">
                          <Bot size={12} /> LYWO AI
                        </div>
                      )}
                      {msg.text}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="p-3 border-top bg-white d-flex justify-content-end gap-3 shadow-sm">
          
            <CustomButton title="Respctfully Decline" buttonType="secondary"
            handleClick={() => setMails({isOpen:true,type:""})}
            />
            <CustomButton title="Advance Candidate" 
            handleClick={() => setMails({isOpen:true,type:""})}
            />
          {/* <button className="btn btn-link text-danger px-4 text-decoration-none">
            Respectful Decline
          </button>
          <button className="btn btn-primary-brand px-4 d-flex align-items-center gap-1">
            Advance Candidate <ChevronRight size={16} />
          </button> */}
        </div>
      </div>
    </>
                      </SideDrawer>
    </>
  );
}